import React, { PureComponent } from 'react'
import {
  func, shape, string, bool,
} from 'prop-types'

import LinkButton from '@active/react-ui/LinkButton'
import Button from '@active/react-ui/Button'

import { merge } from '../../../../../shared/utils/commonUtils'
import TextHr from '../../../TextHr'
import DefaultComponentLayout, { LayoutContent, ErrorContent } from '../../../Layout'
import CountryChoose from '../../../../Signin/components/CountryChoose'
import ReagreeWaiver from '../../../../Signin/components/ReagreeWaiver'
import ReagreeWaiverConfirm from '../../../../Signin/components/ReagreeWaiverConfirm'
import './FacebookBindAccount.scss'
import I18nMessage from '../../../I18nMessage'

class FacebookBindAccount extends PureComponent {
  static propTypes = {
    response: shape({ email: string.isRequired }).isRequired,
    facebookBindAccount: func.isRequired,
    signinSuccessCallback: func,
    handleReturn: func.isRequired,
    configureTrack: func.isRequired,
    defaultHandleComplete: func.isRequired,
    countryCodes: string,
    clientConfig: shape({
      suppressActiveWaiver: bool,
      useCustomizeWaiver: bool,
      waiverAttachementObjectIds: string,
    }).isRequired,
  }

  static defaultProps = {
    countryCodes: undefined,
    signinSuccessCallback: undefined,
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedCountryCode: '',
      isCountryChooseShow: false,
      isReagreeWaiverShow: false,
      isReagreeWaiverConfirmShow: false,
      isBack: false,
      showReagreeWaiverError: false,
      showCountryChooseError: false,
      resetAgrees: {},
    }
  }

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'BindAccount',
      widget: 'bind_account',
      pageType: 'bind account',
    })
  }

  setErrorType = type => {
    this.setState({
      showError: false,
      showReagreeWaiverError: false,
      showCountryChooseError: false,
    })
    switch (type) {
      case 'showReagreeWaiverError':
        this.setState({
          showReagreeWaiverError: true,
        })
        break
      case 'showCountryChooseError':
        this.setState({
          showCountryChooseError: true,
        })
        break
      default:
        this.setState({
          showError: true,
        })
    }
  }

  clickBindAccount = () => {
    this.bindAccount({})
  }

  bindAccount = values => {
    const {
      response,
      facebookBindAccount,
      signinSuccessCallback,
      countryCodes,
      defaultHandleComplete,
      clientConfig: {
        suppressActiveWaiver,
        useCustomizeWaiver,
        waiverAttachementObjectIds,
      },
    } = this.props

    const { selectedCountryCode, ...rest } = values
    let params = {
      ...response,
      countriesInfo: countryCodes,
      suppressActiveWaiver,
      useCustomizeWaiver,
      waiverAttachementObjectIds,
      ...rest,
    }
    if (selectedCountryCode) {
      params = Object.assign(params, { selectedCountryCode })
    }

    let nextState = {}

    facebookBindAccount({
      params: params,
      resolve: ({
        status, message, loginURL, ssoToken, accountCountryCode, ...responseRest
      }) => {
        if (status === 'SUCCESS'
          // Ignore PSW_NOT_QUALFIED due to it is a third party and password isnot the identity code
          || status === 'PSW_NOT_QUALFIED') {
          this.setState({
            isCountryChooseShow: false,
            isReagreeWaiverShow: false,
            isReagreeWaiverConfirmShow: false,
          })

          if (signinSuccessCallback) {
            signinSuccessCallback({
              email: response.email, status, message, loginURL, ssoToken, accountCountryCode, ...responseRest,
            })
          } else {
            defaultHandleComplete({ loginURL, ssoToken })
          }
        } else if (status === 'WAIVER_EXPIRED') {
          this.setState({
            resetAgrees: true,
            isReagreeWaiverShow: true,
            isBack: !!selectedCountryCode,
            accountCountryCode,
          })
        } else if (status === 'NO_COUNTRY_CODE') {
          this.setState({
            isCountryChooseShow: true,
          })
        } else {
          nextState = merge({
            errorMsg: message,
          })
          this.setErrorType(values.showErrorType || 'showError')
        }
      },
      reject: ({ message }) => {
        nextState = merge({
          errorMsg: message,
        })
        this.setErrorType(values.showErrorType || 'showError')
      },
      complete: () => {
        this.setState(nextState)
      },
    })
  }

  /** modal start */
  /** countryChoose start */
  handleChangeCountry = value => {
    this.setState({
      selectedCountryCode: value,
    })
  }

  handleCountryChooseSubmit = () => {
    const { selectedCountryCode } = this.state
    this.bindAccount({
      selectedCountryCode,
      showErrorType: 'showCountryChooseError',
    })
  }
  /** countryChoose end */

  /** ReagreeWaiver  start */
  handleReagreeWaiverClose = () => {
    this.setState({
      isReagreeWaiverConfirmShow: true,
      isReagreeWaiverShow: false,
    })
  }

  handleReagreeWaiverSubmit = () => {
    const { selectedCountryCode } = this.state
    this.bindAccount({
      selectedCountryCode,
      reagree: true,
      showErrorType: 'showReagreeWaiverError',
    })
  }

  handleBack = () => {
    this.setState({
      isReagreeWaiverShow: false,
      isCountryChooseShow: true,
    })
  }

  handleReagreeWaiverCheckboxChange = () => {
    this.setState({
      resetAgrees: false,
    })
  }
  /** ReagreeWaiver  end */

  /** ReagreeWaiverConfirm  start */
  resetWaiver = () => {
    this.setState({
      isReagreeWaiverConfirmShow: false,
      isReagreeWaiverShow: false,
      isCountryChooseShow: false,
      selectedCountryCode: undefined,
    })
  }

  handleCancel = () => {
    this.setState({
      isReagreeWaiverShow: true,
      isReagreeWaiverConfirmShow: false,
    })
  }

  /** ReagreeWaiverConfirm  end */

  /** modal end  */

  render() {
    const { handleReturn, ...rest } = this.props
    const {
      errorMsg,
      showError,
      isBack,
      accountCountryCode,
      isCountryChooseShow,
      isReagreeWaiverShow,
      isReagreeWaiverConfirmShow,
      showReagreeWaiverError,
      showCountryChooseError,
      resetAgrees,
    } = this.state

    return (
      <DefaultComponentLayout nameSpace="passport-ui-app__facebook-bind-account">
        <LayoutContent title message="passport.facebook.bindAccount.title" />
        <LayoutContent subTitle message="passport.facebook.bindAccount.subTitle" />
        <LayoutContent main>
          <CountryChoose
            isCountryChooseShow={isCountryChooseShow}
            handleChangeCountry={this.handleChangeCountry}
            handleCountryChooseModalClose={this.resetWaiver}
            handleCountryChooseSubmit={this.handleCountryChooseSubmit}
            errorMsg={errorMsg}
            showCountryChooseError={showCountryChooseError}
          />
          <ReagreeWaiver
            isBack={isBack}
            selectedCountryCode={accountCountryCode}
            isReagreeWaiverShow={isReagreeWaiverShow}
            handleReagreeWaiverClose={this.handleReagreeWaiverClose}
            handleReagreeWaiverSubmit={this.handleReagreeWaiverSubmit}
            handleBack={this.handleBack}
            errorMsg={errorMsg}
            showReagreeWaiverError={showReagreeWaiverError}
            resetAgrees={resetAgrees}
            handleReagreeWaiverCheckboxChange={this.handleReagreeWaiverCheckboxChange}
            {...rest}
          />
          <ReagreeWaiverConfirm
            handleReagreeWaiverConfirmClose={this.resetWaiver}
            isReagreeWaiverConfirmShow={isReagreeWaiverConfirmShow}
            handleCancel={this.handleCancel}
            handleClose={this.resetWaiver}
            errorMsg={errorMsg}
          />
          {showError && <ErrorContent errorMsg={errorMsg} />}

          <hr className="hr-text" />
          <I18nMessage id="passport.facebook.bindAccount.doYou" />
          <br />
          <Button type="super" onClick={this.clickBindAccount} className="facebook-bind-account__connect">
            <I18nMessage id="passport.facebook.bindAccount.connect" />
          </Button>
          <TextHr id="passport.common.text.or" className="text-uppercase" />
          <div className="center">
            <LinkButton onClick={handleReturn} role="link" tabIndex={0}>
              <I18nMessage id="passport.facebook.bindAccount.joinWith" />
            </LinkButton>
          </div>
        </LayoutContent>
      </DefaultComponentLayout>
    )
  }
}

export default FacebookBindAccount
